import FirstPlaceIcon from 'assets/images/icon-first-place.svg'
import SecondPlaceIcon from 'assets/images/icon-second-place.svg'
import ThirdPlaceIcon from 'assets/images/icon-third-place.svg'
import RandomPrizeIcon from 'assets/images/random-prize.png'

import { FC, memo, useState } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectQuiz } from 'store/quiz/quizSelectors';
import { selectResult } from 'store/player/playerSelectors';
import IQuiz from 'models/Quiz';
import IResult from 'models/Result';
// Utilities
import { buildUserName, getEndOfPlace } from 'utilities/Utilities';

import classes from './styles.module.css';

const Letter:FC<{ letter: string; index: number }> = ({ letter, index }) => {
  const [flip, setFlip] = useState<boolean>(false);

  setTimeout(() => {
    setFlip(true);
  }, 100 * index);

  return (
    <span className={`
      ${flip ? classes.flip : ''}
      ${!letter.trim() ? classes.space : ''}
    `}>
      {flip ? letter : null}
    </span>
  );
}

const Word:FC<{ word: string }> = ({ word }) => (
  <span>
    {Array.from(word).map((letter, index) => (
      <Letter key={index} letter={letter} index={index} />
    ))}
  </span>
)

type Props = {
  result: IResult;
  resultIndex: number;
  randomPrize?: boolean;
}

const ResultItem:FC<Props> = ({ result, resultIndex, randomPrize = false }) => {
  const icons = [FirstPlaceIcon, SecondPlaceIcon, ThirdPlaceIcon];

  const quizResult:any = useAppSelector(selectResult);
  const storeQuiz = useAppSelector(selectQuiz);
  const quiz:IQuiz | null = storeQuiz || quizResult?.quiz || null;

  const primaryColor = quizResult.quizGroup ? quizResult.quizGroup.publicLeaderboard.primaryColor
    : quiz?.publicLeaderboard.primaryColor;
  
  return (
    <li
      className="flex items-center pb-2 mb-2 xl:mb-6 px-4 gap-1 font-medium uppercase sm:text-3xl" 
    >
      <div className="flex-1 flex items-center gap-2">
        <div className="w-12 sm:w-32 flex justify-center">
          {resultIndex > 2 ? (
            randomPrize ? (
              <img src={RandomPrizeIcon} alt="Random-Prize" className="h-11" /> 
            ) : (
              <span style={{ color: primaryColor }}>{`${result.position}${getEndOfPlace(result.position)}`}</span>
            )
          ) : (
            <img src={icons[resultIndex]} alt={`Prize-${resultIndex + 1}`} className={`${resultIndex === 0 ? 'h-12' : 'h-9'}`} /> 
          )}
        </div>
        <Word word={buildUserName(result)} />
      </div>
      <div>
        <Word word={`${result.score.toLocaleString('us-US')} PTS`} />
      </div>
    </li>
  );
}

export default memo(ResultItem);
